import axios from "@/axios";

    export const namespaced = true

    export const state = {
        paymentMethods: []
    }
    
    export const getters = {
        paymentMethods: (state) => {return state.paymentMethods}
    }
    export const mutations = {
        SET_PAYMENT_METHODS: (state, Payments) => (state.paymentMethods = Payments.data),

    }    

    export const actions = {
        async getPaymentMethods({ commit}) {
            // if we already have it in the state dont waste time reloading the same data
            // but if we need to do a pull after an add or update trigg the force
            

            const response = await axios.get("/api/paymentMethods");
            commit("SET_PAYMENT_METHODS", response);
        }
    }

